import React, { useState } from "react";
import {
	Box,
	Container,
	Typography,
	TextField,
	Button,
	CircularProgress,
	Alert,
} from "@mui/material";
import axios from "../api/axios";
import useAuth from "../hooks/useAuth";
import { useNavigate } from "react-router-dom";

const ResetPasswordPage = () => {
	const { auth, setAuth } = useAuth(); // assuming email stored here
	const navigate = useNavigate();

	const [otp, setOtp] = useState("");
	const [newPassword, setNewPassword] = useState("");
	const [repeatPassword, setRepeatPassword] = useState("");
	const [loading, setLoading] = useState(false);
	const [success, setSuccess] = useState(false);
	const [error, setError] = useState("");

	const email = auth?.userEmail; // retrieve email from auth context

	const handleResetPassword = async (e) => {
		e.preventDefault();
		setError("");
		setSuccess(false);
		if (newPassword !== repeatPassword) {
			setError("Passwords do not match");
			return;
		}
		setLoading(true);

		try {
			const response = await axios.patch("/reset-password", {
				email,
				otp,
				password: newPassword,
				repeatPassword,
			});

			if (response.status === 200 && response.data.success) {
				setSuccess(true);
				// Optionally, clear auth state or redirect to login
				setAuth((prev) => ({ ...prev, userEmail: null }));
				// Redirect to login page after success
				navigate("/en/login");
			} else {
				setError(response?.data?.message || "Failed to reset password");
			}
		} catch (err) {
			setError("Network or server error");
		} finally {
			setLoading(false);
		}
	};

	return (
		<Container
			component="main"
			maxWidth="xs"
			sx={{
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				minHeight: "100vh",
				padding: 2,
			}}>
			<Box
				sx={{
					padding: 4,
					borderRadius: 2,
					boxShadow: 3,
					backgroundColor: "#fff",
				}}>
				<Typography
					variant="h5"
					gutterBottom
					align="center"
					sx={{ fontWeight: 600 }}>
					Reset Password
				</Typography>
				<Typography variant="body2" color="textSecondary" align="center" mb={3}>
					Enter the OTP sent to your email and your new password.
				</Typography>
				{success && (
					<Alert severity="success" sx={{ mb: 2 }}>
						Password has been successfully reset. You can now log in.
					</Alert>
				)}
				{error && (
					<Alert severity="error" sx={{ mb: 2 }}>
						{error}
					</Alert>
				)}
				<form onSubmit={handleResetPassword} noValidate>
					{/* OTP Input */}
					<TextField
						label="OTP"
						required
						fullWidth
						value={otp}
						onChange={(e) => setOtp(e.target.value)}
						sx={{ mb: 2 }}
					/>
					{/* New Password */}
					<TextField
						label="New Password"
						type="password"
						required
						fullWidth
						value={newPassword}
						onChange={(e) => setNewPassword(e.target.value)}
						sx={{ mb: 2 }}
					/>
					{/* Repeat Password */}
					<TextField
						label="Repeat Password"
						type="password"
						required
						fullWidth
						value={repeatPassword}
						onChange={(e) => setRepeatPassword(e.target.value)}
						sx={{ mb: 2 }}
					/>
					<Button
						type="submit"
						variant="contained"
						color="primary"
						fullWidth
						disabled={loading}
						startIcon={
							loading && <CircularProgress size={20} color="inherit" />
						}>
						{loading ? "Resetting..." : "Reset Password"}
					</Button>
				</form>
			</Box>
		</Container>
	);
};

export default ResetPasswordPage;
